module.exports = __webpack_public_path__ + "img/docutaxbanner.6ce891a9.jpg";